import classNames from 'classnames';
import Flex from 'components/common/Flex';
import Logo from 'components/common/Logo';
import useApi from 'helpers/api';
import { useAuthenticatedUser } from 'hooks/useAuthenticatedUser';
import useNotification from 'hooks/useNotification';
import { useOAuth2 } from 'hooks/useOAuth2';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';

const PasswordResetForm = ({ hasLabel }) => {
  const api = useApi();
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const { authenticatedUser } = useAuthenticatedUser();
  const { resetOAuthState } = useOAuth2();
  const form = useRef(null);
  // State
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    // userId será usado do authenticatedUser quando necessário
  }, []);

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    e.stopPropagation();
    if (form.current.checkValidity() === false) {
      setValidated(true);
      return;
    }

    try {
      const req = await api.agents.updatePassword(
        authenticatedUser?.id,
        formData
      );
      if (!req.ok) {
        showErrorNotification(req.userMessage);
        return;
      }

      showSuccessNotification('Senha redefinida com sucesso');

      // Limpar todos os cookies de autenticação (previne invalid_grant no próximo login)
      resetOAuthState();

      window.location.href = `${process.env.REACT_APP_BASE_URL}/logout`;
    } catch (error) {
      showErrorNotification('Erro ao redefinir senha: ' + error.message);
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return (
    <Flex
      className="min-vh-100 py-3"
      alignItems="center"
      justifyContent="center"
      direction={'column'}
    >
      <div className="text-center mb-4">
        <Logo width={'250px'} isLink={false} />
      </div>
      <Card style={{ width: '100%', maxWidth: '500px' }} className="mx-3">
        <Card.Header>
          <h3>Redefinição de Senha</h3>
        </Card.Header>
        <Card.Body>
          <Form
            validated={validated}
            ref={form}
            className={classNames('text-left')}
          >
            <Form.Group className="mb-3">
              <Form.Label>Senha Atual</Form.Label>
              <Form.Control
                placeholder={!hasLabel ? 'Senha Atual' : ''}
                value={formData.currentPassword}
                name="currentPassword"
                onChange={handleFieldChange}
                type="password"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label controlId="newPassword">Nova Senha</Form.Label>
              <Form.Control
                placeholder={!hasLabel ? 'Nova Senha' : ''}
                value={formData.newPassword}
                name="newPassword"
                onChange={handleFieldChange}
                type="password"
                pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=\S+$).{8,}$"
              />
              <Form.Control.Feedback type="invalid">
                A senha deve ter 8 caracteres, incluindo pelo menos uma letra
                maiúscula, um número e um caractere especial.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label controlId="confirmPassword">
                Confirme a Senha
              </Form.Label>
              <Form.Control
                placeholder={!hasLabel ? 'Confirme a Senha' : ''}
                value={formData.confirmPassword}
                name="confirmPassword"
                onChange={handleFieldChange}
                type="password"
                pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=\S+$).{8,}$"
              />
              <Form.Control.Feedback type="invalid">
                A senha deve ter 8 caracteres, incluindo pelo menos uma letra
                maiúscula, um número e um caractere especial.
              </Form.Control.Feedback>
            </Form.Group>

            <Button
              type="submit"
              onClick={handleSubmit}
              className="w-100"
              disabled={
                !formData.newPassword ||
                !formData.confirmPassword ||
                formData.newPassword.trim() !== formData.confirmPassword.trim()
              }
            >
              Redefinir senha
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Flex>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default PasswordResetForm;
